import GenerateUrl from "@hedgefund/shared/src/GenerateUrl";
import { put, takeLatest } from "redux-saga/effects";
import { getUtil } from "../../services/axiosClient";
import { API } from "../../utils/Constant";
import * as type from "./constants";

const getAllocatorParams = [
  { keyword: "Keyword", value: "keyword" },
  { keyword: "MinVal", value: "min" },
  { keyword: "MaxVal", value: "max" },
  { keyword: "Page", value: "page" },
  { keyword: "PerPage", value: "perPage" },
];



export function* searchAllocators({ payload }) {
  yield put({ type: type.GET_SEARCH_ALLOCATORS_REQUEST });
  try {
    let url = API.searchAllocators + GenerateUrl(payload, getAllocatorParams)
    const res = yield getUtil(url
    );
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: type.GET_SEARCH_ALLOCATORS_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: type.GET_SEARCH_ALLOCATORS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* SearchAllocatorSaga() {
  yield takeLatest(type.GET_SEARCH_ALLOCATORS_ACTION, searchAllocators);
}
